import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
var themeOptions = function () {
  return {
    components: {
      MuiTabs: {
        defaultProps: {
          indicatorColor: 'secondary',
          textColor: 'secondary'
        },
        styleOverrides: {
          indicator: {
            height: '4px'
          }
        }
      },
      MuiTab: {
        defaultProps: {
          disableRipple: true
        },
        styleOverrides: {
          root: {
            textTransform: 'none',
            fontSize: designTokens.typography.body.short2.size.value
          }
        }
      }
    }
  };
};
export default themeOptions;